import { QueryClient, QueryClientProvider } from 'react-query'
import {Provider} from 'react-redux'
import {
  Route,
  BrowserRouter as Router,
  Switch
} from 'react-router-dom'

import { LicenseInfo } from '@material-ui/x-grid'
import AuthPage from '../pages/AuthPage'
import { useAutoAuth } from '../queries/useAutoAuth'
import HttpInterceptor from '../util/HttpInterceptor'
import styles from './App.module.css'
import store from './store'
import DispatchPage from "../pages/DispatchPage/DispatchPage";
import React, {useEffect} from "react";
import {Container} from "@material-ui/core";
import DispatchViewerPage from "../pages/DispatchPage/DispatchViewerPage";
import {useNetworkStatus} from "../queries/useNetworkStatus";
import {getConfig} from "../AppConfig";
import DispatchTestPage from "../pages/DispatchPage/DispatchTestPage";
import PhonePage from "../pages/FieldSystemPage/PhonePage";
import MainPage from "../pages/FieldSystemPage/MainPage";
import WorkReportingPage from "../pages/WorkReportingPage";
import PDFPage from "../pages/PDFPage";
import SpreadsheetPage from "../pages/SpreadsheetPage/SpreadsheetPage";

// LicenseInfo.setLicenseKey(
//   '5d197bb51445f4132825e19d5d148671T1JERVI6Mjc2MjEsRVhQSVJZPTE2NTkxMDU3NzIwMDAsS0VZVkVSU0lPTj0x'
// )
LicenseInfo.setLicenseKey(
    '280a2fbbe94db0bc3b05638ca37708a6Tz0xMjAzNzgsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

export enum PagePathTypes {
  auth = '/auth',
  home = '/home',
  version = '/version',
  // fieldsystem = '/',
  fieldsystem = '/fieldsystem/:userGuid',
  workreporting = '/workreporting/:userGuid',
  fieldsystemphone = '/',
  dispatch = '/dispatch/:userGuid',
  dispatchremovedb = '/dispatchremovedb',
  dispatchOpenViewer = '/dispatch/open/:id',
  // pdfpage = '/fieldsystem/pdfpage/:driveid/:woid/:generalformsid/:filename/:save/:readonly',
  pdfpage = '/filesystem/pdfpage/:driveid/:woid',
  spreadsheet = '/filesystem/spreadsheet/:driveid/:woid',
}
const queryClient = new QueryClient()

const AutoAuth = ({ children }) => {
  useAutoAuth()
  return children
}

const NetworkStatus = ({ children }) => {
    useNetworkStatus()
    return children
}

export const App: React.FC =  () => {

    // useEffect(() => {
    //     showEstimatedQuota();
    //
    //     //Make sure the storage is persistent.
    //     isStoragePersisted().then(async isPersisted => {
    //         if (isPersisted) {
    //             console.log(":) Storage is successfully persisted.");
    //         } else {
    //             console.log(":( Storage is not persisted.");
    //             console.log("Trying to persist..:");
    //             if (await persist()) {
    //                 console.log(":) We successfully turned the storage to be persisted.");
    //             } else {
    //                 console.log(":( Failed to make storage persisted");
    //             }
    //         }
    //     });
    // }, [])
//     async function persist() {
//         return await navigator.storage && navigator.storage.persist &&
//             navigator.storage.persist();
//     }
//
//
// //This function checks if the storage is persistent.
// //(Copied from https://dexie.org/docs/StorageManager)
//     async function isStoragePersisted() {
//         return await navigator.storage && navigator.storage.persisted &&
//             navigator.storage.persisted();
//     }
//
//
// //This function logs to console how much data is available.
// //(Copied from https://dexie.org/docs/StorageManager)
//     async function showEstimatedQuota() {
//         if (navigator.storage && navigator.storage.estimate) {
//             const estimation = await navigator.storage.estimate();
//             console.log(`Quota: ${estimation.quota}`);
//             console.log(`Usage: ${estimation.usage}`);
//         } else {
//             console.error("StorageManager not found");
//         }
//     }

    const { version } = getConfig()
    console.log(window.location.hostname)
  return (
    <QueryClientProvider client={queryClient}>
      <HttpInterceptor />
      <Provider store={store}>
        <div className={styles.app}>
          <Router>
              <Switch>
                  <NetworkStatus>
                    <Route exact path={PagePathTypes.version}>
                      <Container
                          style={{
                              padding: '0px 0 0 0px',
                              width: '100%',
                              height: '100%',
                              justifySelf: 'center',
                              display: 'flex',
                              flexDirection: 'row'
                          }}>
                          <div style={{ display: 'flex', alignItems: 'center'}}>{version}</div>
                      </Container>
                    </Route>
                    <Route path={PagePathTypes.auth}>
                      <AuthPage />
                    </Route>
                    <Route exact path={PagePathTypes.dispatch}>
                        <Container
                            style={{
                              padding: '84px 0 0 0px',
                              width: '100%',
                              height: '100%',
                              justifySelf: 'center',
                              display: 'flex',
                              flexDirection: 'column'
                            }}>
                          <DispatchPage />
                        </Container>
                    </Route>
                      <Route exact path={PagePathTypes.pdfpage}>
                          <PDFPage />
                      </Route>

                      <Route exact path={PagePathTypes.spreadsheet}>
                          <SpreadsheetPage />
                      </Route>

                      <Route exact path={PagePathTypes.fieldsystem}>
                          {(window.location.hostname.toLowerCase().includes('testfieldsystem\.') || window.location.hostname.toLowerCase().includes('fieldsystem\.')) &&
                              <Container
                                  style={{
                                      padding: '84px 0 0 0px',
                                      // width: '100%',
                                      // height: '100%',
                                      // justifySelf: 'center',
                                      // display: 'flex',
                                      // flexDirection: 'column'
                                  }}>
                                  <MainPage />
                              </Container>
                          }
                      </Route>
                      <Route exact path={PagePathTypes.workreporting}>
                          {(window.location.hostname.toLowerCase().includes('testfieldsystem\.') || window.location.hostname.toLowerCase().includes('fieldsystem\.')) &&
                              <Container
                                  style={{
                                      padding: '84px 0 0 0px',
                                      width: '100%',
                                      height: '100%',
                                      justifySelf: 'center',
                                      display: 'flex',
                                      flexDirection: 'column'
                                  }}>
                                  <WorkReportingPage />
                              </Container>
                          }
                      </Route>
                      <Route exact path={PagePathTypes.fieldsystemphone}>
                          {(window.location.hostname.toLowerCase().includes('testfieldsystem\.') || window.location.hostname.toLowerCase().includes('fieldsystem\.')) &&
                              <Container
                                  style={{
                                      padding: '84px 0 0 0px',
                                      width: '100%',
                                      height: '100%',
                                      justifySelf: 'center',
                                      display: 'flex',
                                      flexDirection: 'column'
                                  }}>
                                  <PhonePage />
                              </Container>
                          }
                      </Route>
                      <Route exact path={PagePathTypes.dispatchremovedb}>
                          <Container
                              style={{
                                  padding: '84px 0 0 0px',
                                  width: '100%',
                                  height: '100%',
                                  justifySelf: 'center',
                                  display: 'flex',
                                  flexDirection: 'column'
                              }}>
                              <DispatchTestPage />
                          </Container>
                      </Route>
                    <Route exact path={PagePathTypes.dispatchOpenViewer}>
                      <Container
                          style={{
                            padding: '84px 0 0 0px',
                            width: '100%',
                            height: '100%',
                            justifySelf: 'center',
                            display: 'flex',
                            flexDirection: 'column'
                          }}>
                        <DispatchViewerPage />
                      </Container>
                    </Route>
                </NetworkStatus>
              </Switch>
          </Router>
        </div>
      </Provider>
    </QueryClientProvider>
  )
}
